var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "progress-container" },
    [
      _c("div", { staticClass: "progress mb-3" }, [
        _c("div", {
          staticClass: "progress-bar",
          style: _vm.progressWidth,
          attrs: {
            role: "progressbar",
            "aria-valuenow": "10",
            "aria-valuemin": "0",
            "aria-valuemax": "100"
          }
        })
      ]),
      _c(
        "v-layout",
        { staticClass: "progress-text" },
        [
          _c("v-flex", { staticClass: "text-left" }, [
            _c("span", { staticClass: "font-xs-bariol active" }, [
              _vm._v(" Registra el"),
              _c("br"),
              _vm._v("negocio")
            ])
          ]),
          _c("v-flex", { staticClass: "text-xs-center" }, [
            _c(
              "span",
              {
                staticClass: "font-bariol",
                class: { active: _vm.step >= _vm.startIndex }
              },
              [_vm._v("Configura "), _c("br"), _vm._v("la solución")]
            )
          ]),
          _c("v-flex", { staticClass: "text-xs-right" }, [
            _c(
              "span",
              {
                staticClass: "font-bariol",
                class: { active: _vm.step == _vm.totalSteps }
              },
              [_vm._v("Resumen"), _c("br"), _vm._v("de afiliación")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c4c2e27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c4c2e27","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress-movil.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1c4c2e27","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress-movil.vue
// module chunks = 0 1 2